import { z } from 'zod';

export const CostModel = z.enum(['CPC', 'CPA']);

export type CostModel = z.infer<typeof CostModel>;
